import { render } from "./PageFooter.vue?vue&type=template&id=4cc5fd60&scoped=true"
import script from "./PageFooter.vue?vue&type=script&lang=js"
export * from "./PageFooter.vue?vue&type=script&lang=js"

import "./PageFooter.vue?vue&type=style&index=0&id=4cc5fd60&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cc5fd60"]])

export default __exports__